// Countries selectable when creating / editing a company, with the
// validation rule for each country's tax-ID field.
//
// Thailand uses the strict 13-digit numeric format and keeps the boxed
// OTP-style input (`useOtp: true`). Other countries use a normal text
// field that accepts a variable length and letters, because foreign
// tax / VAT IDs are frequently alphanumeric and not a fixed length.
//
// To support another country, add an entry here — the forms read this
// list directly, so no component changes are needed.

export const DEFAULT_COUNTRY_CODE = 'TH'

const COMPANY_COUNTRIES = [
  {
    code: 'TH',
    nameTH: 'ไทย',
    nameEN: 'Thailand',
    flag: 'https://flagcdn.com/th.svg',
    // Currency the company's own documents are denominated in. Read through
    // libs/currency.js; a country without one falls back to THB.
    currency: 'THB',
    taxId: {
      useOtp: true,        // boxed OTP input
      numericOnly: true,
      exactLength: 13,
    },
  },
  {
    code: 'LA',
    nameTH: 'ลาว',
    nameEN: 'Laos',
    flag: 'https://flagcdn.com/la.svg',
    currency: 'LAK',
    taxId: {
      useOtp: true,       // free-text field
      numericOnly: true,  // allow letters + digits
      exactLength: 12,
      // useOtp: false,       // free-text field
      // numericOnly: false,  // allow letters + digits
      // minLength: 1,
      // maxLength: 12,
    },
  },
]

export function getCompanyCountries() {
  return COMPANY_COUNTRIES
}

// Always returns a config; falls back to the default country (Thailand)
// for an unknown / empty code so legacy companies keep working.
export function getCountryConfig(code) {
  return (
    COMPANY_COUNTRIES.find((c) => c.code === code) ||
    COMPANY_COUNTRIES.find((c) => c.code === DEFAULT_COUNTRY_CODE)
  )
}

// Shared, country-aware validation used by both the add form and the
// edit dialog. Returns true when valid, otherwise a Thai error message.
export function validateTaxId(value, code) {
  const rule = getCountryConfig(code).taxId
  const v = value || ''

  if (!v) return 'กรุณากรอกข้อมูล'

  if (rule.numericOnly && !/^\d+$/.test(v)) {
    return 'เลขประจำตัวผู้เสียภาษีต้องเป็นตัวเลขเท่านั้น'
  }

  if (rule.exactLength && v.length !== rule.exactLength) {
    return `เลขประจำตัวผู้เสียภาษีควรมี ${rule.exactLength} ตัวอักษร`
  }

  if (rule.minLength && v.length < rule.minLength) {
    return `เลขประจำตัวผู้เสียภาษีควรมีอย่างน้อย ${rule.minLength} ตัวอักษร`
  }

  if (rule.maxLength && v.length > rule.maxLength) {
    return `เลขประจำตัวผู้เสียภาษีควรมีไม่เกิน ${rule.maxLength} ตัวอักษร`
  }

  return true
}
